/**
 * Session-48h — Phone number masking.
 *
 * When the current user's `permissions.mobile_view_full` is falsy AND the
 * user is a handler (any *_handler role, not customer / super_admin), we
 * mask every phone number rendered in list/table views to the last 4
 * digits, e.g. `9876500000` → `XXXXXX0000`.
 *
 * Deep-drill views (Customer Profile, Edit Client Modal) can pass
 * `forceFull={true}` to always render the full number.
 */
export const maskPhone = (phone, user, { forceFull = false } = {}) => {
  if (!phone) return '';
  const s = String(phone).replace(/\s+/g, '');
  if (forceFull) return s;
  const role = (user?.role || '').toLowerCase();
  const isHandler = role.endsWith('_handler');
  if (!isHandler) return s; // super_admin + customer see everything
  const allowFull = !!(user?.permissions?.mobile_view_full);
  if (allowFull) return s;
  if (s.length <= 4) return s;
  return 'X'.repeat(Math.max(0, s.length - 4)) + s.slice(-4);
};

export default maskPhone;
